import { useRef } from "react"

const useTrapFocus = () => {
  const parentNode = useRef(null)

  const trapFocus = e => {
    const tabs = Array.from(parentNode.current.querySelectorAll("button[role=tab]:not([disabled])"))
    const currentIndex = tabs.indexOf(document.activeElement)
    const firstIndex = 0
    const lastIndex = tabs.length - 1
    let nextIndex = currentIndex

    switch (e.key) {
      case "ArrowRight":
        nextIndex = currentIndex === lastIndex ? firstIndex : currentIndex + 1
        tabs[nextIndex].focus()
        break
      case "ArrowLeft":
        nextIndex = currentIndex === firstIndex ? lastIndex : currentIndex - 1
        tabs[nextIndex].focus()
        break
      default:
        break
    }
  }

  return [parentNode, trapFocus]
}

export default useTrapFocus
